import type { AssetsProductType, DjangoErrorResponse, VerificationType } from 'api/types';

export const isDjangoErrorResponse = (error: unknown): error is DjangoErrorResponse => {
  return typeof error === 'object' && error !== null && 'code' in error && 'detail' in error;
};

type ReportType = Exclude<VerificationType, 'transactions' | 'scoring_attrs' | AssetsProductType>;

export function getEndpointByType(type: ReportType, linkId?: string) {
  const typeMap: Record<ReportType, string> = {
    income: '/v1/reports/income/',
    employment: '/v1/reports/employment/',
    deposit_switch: `/p/v1/links/${linkId}/direct_deposit/report/`,
    pll: `/p/v1/links/${linkId}/pll/report/`,
    admin: '/p/v1/administrators/directories/',
    insurance: '/v1/reports/insurance/',
    education: `/p/v1/links/${linkId}/education/`,
  };

  return typeMap[type];
}
